import { useState, useEffect } from 'react'
import keys from 'lodash/keys'
import compact from 'lodash/compact'
import { ColorProps, PropertiesOptions } from 'src/types/Main'
import clearColorTitle from 'src/components/utils/clearColorTitle'
import { clearColorHexa, isMulticolor } from 'src/components/utils/clearColorHexa'
import { translateString } from '../../../../utils/translateString'

interface Props {
  propertyType: string
  filter: PropertiesOptions
  filteredProperties: Record<string, string[]>
  setFilteredProperties(properties: Record<string, string[]>): void
  filterOnClick: boolean
  colorsProps: ColorProps
}

const normalizeColorValue = (value: string): string => value.replace(/%23/g, '#')

const ColorValue = (props: Props) => {
  const {
    propertyType,
    filter,
    filteredProperties,
    setFilteredProperties,
    colorsProps
  } = props

  const showColor = colorsProps.showColor && clearColorHexa(filter.value) !== undefined

  const [selected, setSelected] = useState(
    keys(filteredProperties).some((tagId) => {
      if (tagId === propertyType) {
        return filteredProperties[tagId].some((tagName) => {
          const normalizedTagNameColors = normalizeColorValue(tagName).split(',').map((color) => color.trim())
          const normalizedFilterValueColors = normalizeColorValue(filter.value).split(',').map((color) => color.trim())

          return normalizedFilterValueColors.every((color) => normalizedTagNameColors.includes(color))
        })
      }
      return false
    })
  )

  const handlesFilter = async (value: string) => {
    const normalizedValue = normalizeColorValue(value)
    if (selected) {
      filteredProperties[propertyType].splice(
        filteredProperties[propertyType].indexOf(normalizedValue),
        1
      )
      setFilteredProperties({
        ...filteredProperties,
        [propertyType]: filteredProperties[propertyType]
      })
    } else {
      setFilteredProperties({
        ...filteredProperties,
        [propertyType]: compact([normalizedValue].concat(filteredProperties[propertyType]))
      })
    }
    setSelected(!selected)
  }

  useEffect(() => {
    setSelected(
      keys(filteredProperties).some((tagId) => {
        if (tagId === propertyType) {
          return filteredProperties[tagId].some((tagName) => {
            const normalizedTagNameColors = normalizeColorValue(tagName).split(',').map((color) => color.trim())
            const normalizedFilterValueColors = normalizeColorValue(filter.value).split(',').map((color) => color.trim())

            return normalizedFilterValueColors.every((color) => normalizedTagNameColors.includes(color))
          })
        }
        return false
      })
    )
  }, [filteredProperties])

  const title = colorsProps.showTitle
    ? (<div className="color-value-text">{translateString(clearColorTitle(filter.value) || '')}</div>)
    : null

  const color = showColor
    ? (<div
        style={{
          background: filter.pattern
            ? `url('${filter.pattern}') no-repeat scroll center`
            : isMulticolor(filter.value)
              ? `linear-gradient(50deg, ${clearColorHexa(filter.value)})`
              : clearColorHexa(filter.value)
        }}
        className="color-value-name"></div>
      )
    : null

  return (
    <div
      className={`color-value-container ${
        selected
          ? 'label-selected'
          : ''
      }`}
      onClick={() => handlesFilter(filter.value)}
    >
      {color}
      {title}
      <span className="list-value-count">
        {filter.count}
      </span>
    </div>
  )
}

export default ColorValue
